<template>
  <v-container class="pa-0">
    <v-card :loading="loading">
      <v-card-title> Top 5 {{ mode }} </v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="list in list_data" :key="list.username">
              <td>{{ list.username }}</td>
              <td>{{ list.total }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "Top5List",
  props: ["mode", "list_data", 'loading'],
  data() {
    return {};
  },
};
</script>
